import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService} from '@app/services';
import {Marker} from '../../marker';
import {MarkerService} from '../../marker.service';
@Component({
  selector: 'hpf-marker-edit',
  templateUrl: './marker-edit.component.html'
})
export class MarkerEditComponent implements OnInit, OnDestroy {
  /** The marker */
  marker = new Marker();
  /** The marker */
  private id: string;
  /** The id subscription */
  private idSubscription: RxJsSubscription;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private errorService: ErrorService,
              private markerService: MarkerService) {}
  /** Init */
  ngOnInit() {
    // Get the marker after reading the id
    this.idSubscription = this.route.params.subscribe(params => {
        this.id = params['id'];
        this.refresh();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.idSubscription.unsubscribe();
  }
  /** Fetch marker from API */
  private refresh() {
    this.markerService.get(this.id, { _populate: ['*'] })
      .then((marker: Marker) => {
        this.marker.fromObject(marker.toObject());
      })
      .catch((error) => this.errorService.handle(error));
  }
  /** Called when the marker is updated */
  onUpdate(): void {
    this.refresh();
  }
  /** Called when the marker is deleted */
  onDelete(): void {
    this.router.navigateByUrl('/marker')
      .catch((error) => this.errorService.handle(error));
  }
}
